appSocial.component('leadersFeed', {
    templateUrl: 'widgets/leaders-feed/components/leaders-feed/LeadersFeedComponent.html',
    bindings: {
        category: '<',
        limit: '<',
        infiniteScroll: '<',
        // possible values: '' - default, 'compare' - compare mode
        mode: '<'
    },
    controller: class LeadersFeedComponent {
        constructor(
            SocialTypes,
            SocialFeedService,
            SocialLocaleService,
            SocialFavoriteService,
            SocialPortfolioService,
            SocialUserService,
            LeadersSearchService,
            SocialUtils,
            $ionicLoading,
            $rootScope,
            $timeout) {

            /**
             * @type SocialFeedService
             */
            this.feedService = SocialFeedService;
            /**
             * @type {SocialFavoriteService}
             */
            this.favoriteService = SocialFavoriteService;
            /**
             * @type {SocialPortfolioService}
             */
            this.portfolioService = SocialPortfolioService;
            /**
             * @type {SocialUserService}
             */
            this.userService = SocialUserService;
            /**
             * @type {LeadersSearchService}
             */
            this.leadersSearchService = LeadersSearchService;

            this.$ionicLoading = $ionicLoading;

            this.utils = SocialUtils;

            this.translation = SocialLocaleService.translation;
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;

            this.traders = [];

            const FilterTag = SocialTypes.FilterTag;
            const FieldOperation = SocialTypes.FieldOperation;
            const Dir = SocialTypes.Dir;
            const Op = SocialTypes.Op;

            this.feedFilters = {
                [FilterTag.MostCopied]: {
                    fields: [
                        {
                            name: 'followers_count',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        },
                        {
                            name: 'gain',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        }
                    ],
                    order: [
                        {
                            name: 'followers_count',
                            dir: Dir.Desc
                        }
                    ],
                    dateRange: 'thisTwoYears'
                },
                [FilterTag.EditorsChoice]: {
                    fields: [
                        {
                            name: 'gain',
                            op: FieldOperation.GreaterThan,
                            value: -10,
                            next: Op.And
                        },
                        // {
                        //     name: 'profit',
                        //     op: FieldOperation.GreaterThan,
                        //     value: 1000,
                        //     next: Op.And
                        // },
                        {
                            name: 'trades_count',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        },
                    ],
                    order: [
                        {
                            name: 'gain',
                            dir: Dir.Desc
                        },
                        {
                            name: 'trades_count',
                            dir: Dir.Desc
                        },
                        {
                            name: 'profit',
                            dir: Dir.Desc
                        },
                    ],
                    dateRange: 'lastMonth'
                },
                [FilterTag.Profitable]: {
                    fields: [
                        {
                            name: 'profit',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        },
                        {
                            name: 'gain',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        }
                    ],
                    order: [
                        {
                            name: 'profit',
                            dir: Dir.Desc
                        }
                    ],
                    dateRange: 'thisTwoYears'
                },
                [FilterTag.Trending]: {
                    fields: [
                        {
                            name: 'gain',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        }
                    ],
                    order: [],
                    dateRange: 'thisTwoYears'
                },
                [FilterTag.Top]: {
                    fields: [
                        {
                            name: 'gain',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        },
                        {
                            name: 'invested_capital',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        }
                    ],
                    order: [
                        {
                            name: 'invested_capital',
                            dir: Dir.Desc
                        }
                    ],
                    dateRange: 'lastMonth'
                },
                [FilterTag.Similar]: {
                    fields: [
                        {
                            name: 'gain',
                            op: FieldOperation.GreaterThan,
                            value: 0,
                            next: Op.And
                        }
                    ],
                    order: [
                        {
                            name: 'gain',
                            dir: Dir.Desc
                        },
                        {
                            name: 'trades_count',
                            dir: Dir.Desc
                        },
                        {
                            name: 'profit',
                            dir: Dir.Desc
                        },
                    ],
                    dateRange: 'thisTwoYears'
                },
                'custom-search': {
                    fields: [],
                    order: []
                }
            };

            this.orderFilters = {
                'desc': {
                    fields: null,
                    order: [
                        {
                            name: 'registration_date',
                            dir: Dir.Desc
                        }
                    ]
                },
                'asc': {
                    fields: null,
                    order: [
                        {
                            name: 'registration_date',
                            dir: Dir.Asc
                        }
                    ]
                }
            };

            this.isLoading = false;

            this.noData = true;

            this.page = 0;

            this.order = 'desc';
        }

        $onInit() {
            // reset search for predefined categories
            if (this.category && this.category.id !== 'custom-search') {
                this.leadersSearchService.reset();
            }

            this.updateFeed();
        }

        $onChanges(changes) {
            if (changes.category && changes.category.currentValue) {
                this.updateFeed();
            }
        }

        $onDestroy() {
            console.log('on destroy')
        }

        updateFeed(more = false) {
            console.log('[CATEGORY]', this.category);
            let searchFields = {
                fields: [],
                order: [],
            };

            // TODO - fill search fields from search service
            if (this.category && this.category.id === 'custom-search') {
                searchFields = this.leadersSearchService.createFields();
                this.order = this.leadersSearchService.order;
            }

            searchFields.limit = Number(this.limit);
            searchFields.page = Number(this.page);

            const feedFields = this.feedFilters[this.category.id];
            const orderFields = this.orderFilters[this.order];

            console.warn('SEARCH FIELDS:', _.cloneDeep(searchFields));
            console.warn('FEED FIELDS:', _.cloneDeep(feedFields));
            console.warn('ORDER FIELDS:', this.order, _.cloneDeep(orderFields));

            if (feedFields) {
                searchFields.fields = _.concat(searchFields.fields, feedFields.fields);
                searchFields.order = _.concat(searchFields.order, feedFields.order, orderFields.order);
                if (feedFields.dateRange) {
                    searchFields.dateRange = feedFields.dateRange;
                }
            } else {
                searchFields.order = _.concat(searchFields.order, orderFields.order);
            }
            // }

            console.warn('COMBINED SEARCH FIELDS:::', this.category, _.cloneDeep(searchFields));

            // for the first loading only! - prefill traders with fake values to show loaders
            if (this.page === 0) {
                this.traders = Array(searchFields.limit).fill(null).map((item, index) => index);
            }

            this.isLoading = true;

            return this.feedService.get(searchFields)
                .then(traders => {

                    this.noData = !traders.length

                    if (this.noData) {
                        this.$rootScope.$broadcast('scroll.infiniteScrollComplete');
                        this.isLoading = false;

                        //first load - remove prefilled traders
                        if (!more) {
                            this.traders = [];
                        }
                        return;
                    }

                    if (more) {
                        this.traders = _.concat(this.traders, traders);
                    } else {
                        this.traders = traders;
                    }

                    //set favorite
                    this.setFavorites(this.traders);

                    //set followed
                    this.setFollowed(this.traders);

                    this.isLoading = false;
                })
                .catch(error => {
                    console.warn('got error', error);
                    this.isLoading = false;
                })
        }

        toggleTrader(trader) {
            // collapse all other traders
            this.traders
                .filter(item => item.id !== trader.id)
                .forEach(item => item.expanded = false);
        }

        loadMore() {
            this.page++;
            return this.updateFeed(true)
                .then(() => {
                    this.$rootScope.$broadcast('scroll.infiniteScrollComplete');
                });
        }

        resetSearch() {
            this.leadersSearchService.reset();
            this.utils.navigate('root.app.social', {category: 'all', nonce: Date.now()}, true);
        }

        /**
         * @param {Trader[]} traders
         */
        setFavorites(traders) {
            traders.forEach(trader => trader && (trader.isFavorite = this.favoriteService.isFavorite(trader.id)));
        }

        /**
         * @param {Trader[]} traders
         */
        setFollowed(traders) {
            traders.forEach(trader => trader && this.portfolioService.initLeader(trader));
        }
    }
});
